export const UNSUBSCRIBED_BANNER_COPY = {
  description: 'You can still view your data, but some features are limited.',
  title: 'Your subscription is inactive',
};
